import { render, staticRenderFns } from "./WeiboStats.vue?vue&type=template&id=3ae74ca8&"
import script from "./WeiboStats.vue?vue&type=script&lang=js&"
export * from "./WeiboStats.vue?vue&type=script&lang=js&"
import style0 from "./WeiboStats.vue?vue&type=style&index=0&id=3ae74ca8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports